import { useState, useEffect } from 'react';

export default function BarItemScore({ 
  title,
  score,
  maxScore,
  formattedScore,
  color,
  label,
  alignBarTitle
}) {
  const [animatedWidth, setAnimatedWidth] = useState('0%');
  const [animatedScore, setAnimatedScore] = useState(0);
  const animationSpeed = 25; // pixels per second

  const finalScore = formattedScore || score;
  useEffect(() => {
    if (isNaN(score)) {
      setAnimatedWidth('0%');
      setAnimatedScore('tbd');
      return;
    }
    
    const targetWidthPercentage = (score / (maxScore || 1) * 100);
    const duration = (targetWidthPercentage / animationSpeed) * 1000;

    let elapsed = 0;

    const interval = setInterval(() => {
      elapsed += 10;
      if (elapsed >= duration) {
        clearInterval(interval);
        setAnimatedWidth(`${targetWidthPercentage.toFixed(2)}%`);
        setAnimatedScore(finalScore ? parseFloat(finalScore.toFixed(2)).toString() : 0);
      } else {
        const progress = elapsed / duration;
        setAnimatedWidth(`${(targetWidthPercentage * progress).toFixed(2)}%`);
        setAnimatedScore(Math.round(score * progress));
      }
    }, 10);

    return () => clearInterval(interval);
  }, [score, maxScore, formattedScore]);

  const scoreStyle = {
    width: animatedWidth,
    ...(color && { backgroundColor: color }) // Add backgroundColor property if color prop exists
  };

  return (
    <span
      className="scores-score"
      style={scoreStyle}
    >
      <span>{animatedScore}{label}</span>
    </span>
  );
};
